import request from '@/utils/request'

// 查询共有资金汇总
export function listCommunityFunds(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityFund.listCommunityFunds',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询共有资金明细列表
export function listCommunityFundDetails(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityFund.listCommunityFundDetails',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 导入共有资金明细 - 通过上传接口上传文件
export function uploadCommunityFundFile(formData) {
  return new Promise((resolve, reject) => {
    request({
      url: '/callComponent/upload/uploadVedio/upload',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 导入共有资金明细 - 根据文件URL执行导入
export function importCommunityFundDetails(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communityFund.importCommunityFundDetails',
      method: 'post',
      data: params,
      timeout: 300000  // 导入耗时较长，5分钟超时
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
